"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProfileOfferFilterInputs = void 0;
const create_profile_nft_filter_inputs_1 = require("../profile-page-nft-filters/create-profile-nft-filter-inputs");
const offer_blacklist_json_1 = __importDefault(require("./../../../../../../../offer-blacklist.json"));
function createProfileOfferFilterInputs({ showFilters, allSorts, allFilters, isRenderReady, entries, currentProfileTab, sellCallback, transferCallback, userAccount, nftClickCallback, viewStyle, }) {
    const createProfileFilterInputs = (0, create_profile_nft_filter_inputs_1.createProfileNftFilterInputs)({
        showFilters,
        allSorts,
        allFilters,
        isRenderReady,
        entries,
        currentProfileTab,
        sellCallback,
        transferCallback,
        userAccount,
        nftClickCallback,
        viewStyle,
    });
    const filteredBlacklistedCanisterOffers = {
        ...createProfileFilterInputs,
        allEntries: createProfileFilterInputs.allEntries.filter(entry => {
            return !offer_blacklist_json_1.default.includes(entry.collectionId);
        }),
    };
    return filteredBlacklistedCanisterOffers;
}
exports.createProfileOfferFilterInputs = createProfileOfferFilterInputs;
